<template>
  <div
    v-if="meta.last_page > 1"
    class="pagination"
  >
    <span class="data">Showing {{ meta.to }} items of {{ meta.total }}</span>
    <div class="pagination__list">
      <template
        v-for="(link, index) in meta.links"
      >
        <InertiaLink
          v-if="link.url && Number.isInteger(link.label)"
          :key="index"
          class="pagination__item"
          :class="{ 'pagination__item--active': link.active }"
          :href="link.url"
        >
          {{ link.label }}
        </InertiaLink>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    meta: Object,
  },
}
</script>
